import React, { Component } from 'react';
import { HeaderMain } from '../../Common/HeaderMain'
import { HeaderSub } from '../../Common/HeaderSub'
import { QuestList } from './QuestList';
import { ConverInfo } from './ConverInfo';
import { WhQuestList } from './WhQuestList';
import { Inventory } from '../Answer/Inventory';
import { ChatOrder } from '../Answer/ChatOrder';
import { OrderComplete } from '../Answer/OrderComplete';
import { Footer } from '../../Common/Footer'

import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능: 채팅리스트 인덱스 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.QuestList,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.CsName = Big3Common.ContentState;
    }
    //호출할 컴포넌트 이름
    CompName = {
        "QuestList": "QuestList",
        "ConverInfo": "ConverInfo",
        "WhQuestList": "WhQuestList",
        "Inventory": "Inventory",
        "ChatOrder": "ChatOrder",
        "OrderComplete": "OrderComplete"
    }
    //초기화
    componentDidMount() {
        const Param_Qstgrp_no = Big3Common.Util.GetParams("qstgrp_no");       //링크주소가 있을때
        const Param_Uid = Big3Common.Util.GetParams("uid");
        const Param_Whole_Name = Big3Common.Util.GetParams("whole_name");        
        if (Param_Qstgrp_no !== null && Param_Uid !== null && Param_Whole_Name !== null) {
            //구매내역에서 직접 채팅으로 이동
            const ContentState = {
                [this.CsName.QstgrpNo]: Param_Qstgrp_no,
                [this.CsName.Whole_Name]: Param_Whole_Name,
                [this.CsName.Uid]: Param_Uid
            }
            this.setState({
                ContentState: ContentState,
                RenderName: this.CompName.ConverInfo
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    render() {
        
        if (this.state.RenderName === this.CompName.QuestList) {
            //주문문의 리스트(매장별)
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: "주문문의", LinkYn: "N", LinkUrl: "", ComponentUrl: "" }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <QuestList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer fillName="icon4" />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.WhQuestList) {
            //매장 주문문의 리스트
            const Title = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.Whole_Name, "");
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title }
                        ComponentUrl="QuestList"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <WhQuestList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer fillName="icon4" />
                </div>
            );
        }
        if (this.state.RenderName === this.CompName.ConverInfo) {
            //채팅창
            const Title = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.Whole_Name, "");
            const Param_Qstgrp_no = Big3Common.Util.GetParams("qstgrp_no");       //링크주소가 있을때
            if (Param_Qstgrp_no === null) {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle={Title}
                            ComponentUrl="WhQuestList"
                            ComponentName={this.state.RenderName}
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                        <ConverInfo
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            else {
                return (
                    <div>
                        <HeaderSub
                            HeaderTitle={Title}
                            HistoryBack={true}
                            ComponentName={this.state.RenderName}
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                        <ConverInfo
                            RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                            ContentState={this.state.ContentState}
                        />
                    </div>
                );
            }
            
        }
        if (this.state.RenderName === this.CompName.Inventory) {
            //문의매역, 답변내역
            const QstStatus = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.QstStatus, "");
            const Title = QstStatus === "QA" ? "재고문의" : "재고답변";
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title }
                        ComponentUrl="ConverInfo"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Inventory
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        if (this.state.RenderName === this.CompName.ChatOrder) {
            //주문하기
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="주문하기"
                        ComponentUrl="Inventory"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <ChatOrder
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        if (this.state.RenderName === this.CompName.OrderComplete) {
            //주문완료
            const QstStatus = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.QstStatus, "");
            let Title = "";
            if (QstStatus === "JM") {
                Title = "상품주문";
            }
            else if (QstStatus === "PJ") {
                Title = "포장완료";
            }
            else if (QstStatus === "GR") {
                Title = "거래완료";
            }
            else if (QstStatus === "CS") {
                Title = "주문취소";
            }
            
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title }
                        ComponentUrl="ConverInfo"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <OrderComplete
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }
}
